import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_SCHOOLS_URL;

export default {
  getSchools() {
    return $axios.get('api/v1/school', { baseURL: baseUrl });
  },
  getPagedSchools(paging) {
    return $axios.post('api/v1/school/paged', paging, { baseURL: baseUrl });
  },
  getSchool(id) {
    if (id) {
      return $axios.get(`api/v1/school/details/${id}`, {
        baseURL: baseUrl,
      });
    }
    return $axios.get('api/v1/school/details', { baseURL: baseUrl });
  },
  getSchoolLicenses(id, licenseModels) {
    const params = new URLSearchParams();
    licenseModels.forEach((model) => {
      params.append('licenseModels', model);
    });
    return $axios.get(`api/v1/school/${id}/licenses?${params.toString()}`, {
      baseURL: baseUrl,
    });
  },
  getSchoolForUser() {
    return $axios.get('api/v1/school/details', { baseURL: baseUrl });
  },
  getUnpaidLicenses(licenseModels) {
    const params = new URLSearchParams();
    licenseModels.forEach((model) => {
      params.append('licenseModels', model);
    });
    return $axios.get(`api/v1/school/unpaid?${params.toString()}`, {
      baseURL: baseUrl,
    });
  },
  generateUnpaidLicensesReport(licenseModels) {
    const params = new URLSearchParams();
    licenseModels.forEach((model) => {
      params.append('licenseModels', model);
    });
    return $axios.get(`api/v1/school/unpaid/report?${params.toString()}`, {
      baseURL: baseUrl,
      responseType: 'blob',
    });
  },
  generatePaidLicensesReport(request) {
    return $axios.post('api/v1/school/paid/report', request, {
      baseURL: baseUrl,
      responseType: 'blob',
    });
  },
  getExpiringLicenses() {
    return $axios.get('api/v1/school/expiring', { baseURL: baseUrl });
  },
  getExpiredLicenses() {
    return $axios.get('api/v1/school/expired', { baseURL: baseUrl });
  },
  getActiveLicenses() {
    return $axios.get('api/v1/school/active', { baseURL: baseUrl });
  },
  getPaidLicenses(request) {
    return $axios.post('api/v1/school/paid', request, { baseURL: baseUrl });
  },
  createSchool(school) {
    return $axios.post('api/v1/school/import', school, { baseURL: baseUrl });
  },
  addLicense(schoolId, license) {
    return $axios.post(`api/v1/school/${schoolId}/license`, license, {
      baseURL: baseUrl,
    });
  },
  updateLicense(schoolId, license) {
    return $axios.put(
      `api/v1/school/${schoolId}/license/${license.id}`,
      license,
      { baseURL: baseUrl },
    );
  },
  removeLicense(schoolId, licenseId) {
    return $axios.delete(`api/v1/school/${schoolId}/license/${licenseId}`, {
      baseURL: baseUrl,
    });
  },
  payLicense(schoolId, licenseId, amount) {
    return $axios.post(
      `api/v1/school/${schoolId}/license/${licenseId}/pay`,
      amount,
      { baseURL: baseUrl },
    );
  },
  updateStatus(schoolId, status) {
    return $axios.post(
      `api/v1/school/${schoolId}/status`,
      { status: status },
      {
        baseURL: baseUrl,
      },
    );
  },
  getInvoice(schoolId, licenseId) {
    return $axios.get(
      `api/v1/school/${schoolId}/license/${licenseId}/invoice`,
      {
        baseURL: baseUrl,
        responseType: 'blob',
      },
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/schools.js